import type { Issuer } from "./open-id-connect";
import OpenIdConnectService from "./open-id-connect";

export default class HclConnectMedic extends OpenIdConnectService {
  featureFlag = "enabling_auth_by_hcl_medic";
  imageUrl = "/assets/ui-images/hcl_logo.png";
  issuer: Issuer = "hcl-medic";
  label = "HCL Connect";
  override route = "login.hcl-medics";
}
